import { Flex } from 'antd'
import ClassName from 'clsx'
import Icon, { IconName } from '@/components/icon'
import Styles from './style.module.scss'

export interface FeatureIconsProps {
  icon: IconName
  label: string
  description?: string
}

export default function FeatureIcons({ data, className }: { data?: FeatureIconsProps[]; className?: string }) {
  if (!data?.length) return null

  return (
    <div className={ClassName(Styles.featureIcons, data?.length >= 6 && Styles.grid, className)}>
      {data.map(item => (
        <Flex vertical align='center' key={item.icon} className={Styles.item}>
          <Icon name={item.icon} className={Styles.icon} />
          <div className={Styles.featureIconLabel}>{item.label}</div>
          {!!item.description && <div className={Styles.featureIconDescription}>{item.description}</div>}
        </Flex>
      ))}
    </div>
  )
}
